import { render } from "./KeyFeaturesDesktop.vue?vue&type=template&id=88bda3e8&scoped=true"
import script from "./KeyFeaturesDesktop.vue?vue&type=script&lang=js"
export * from "./KeyFeaturesDesktop.vue?vue&type=script&lang=js"

import "./KeyFeaturesDesktop.vue?vue&type=style&index=0&id=88bda3e8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88bda3e8"]])

export default __exports__